/**
 * dir-w | backOffice
 * User model get default structure reference from interface User
 *
 * Last update : January 10, 2024 | @rizkiprasetya
 */

import { IBasePersonWithReferral } from '../interfaces/person.interface';
import { IBaseReferral } from '../interfaces/referral.interface';
import { IBaseUser, IBaseUserWithReferral } from '../interfaces/user.interface';

export class User implements IBaseUser {
  id: string;
  name: string;
  email: string;
  mobile: string;
  role: {
    id: string;
    caption: string;
    description: string;
  };
  email_verified_at: Date | null;
  created_at: Date | null;
  created_by: string | null;
  updated_at: Date | null;
  updated_by: string | null;
  deleted_at: Date | null;
  deleted_by: string | null;

  constructor(user: IBaseUser) {
    this.id = user.id;
    this.name = user.name;
    this.email = user.email;
    this.mobile = user.mobile;
    this.role = user.role;
    this.email_verified_at = user.email_verified_at;
    this.created_at = user.created_at;
    this.created_by = user.created_by;
    this.updated_at = user.updated_at;
    this.updated_by = user.updated_by;
    this.deleted_at = user.deleted_at;
    this.deleted_by = user.deleted_by;
  }
}

export class UserWithReferral extends User implements IBaseUserWithReferral {
  person: IBasePersonWithReferral | null;
  created_user: IBaseReferral | null;
  updated_user: IBaseReferral | null;
  deleted_user: IBaseReferral | null;

  constructor(user: IBaseUserWithReferral) {
    super(user);
    this.person = user.person;
    this.created_user = user.created_user;
    this.updated_user = user.updated_user;
    this.deleted_user = user.deleted_user;
  }
}
